import { convert } from './convert.js';
import { convertMany } from '.';
export function ms(value) {
    if (typeof value === 'string') {
        return convertMany(value).to('ms');
    }
    return convert(value, 'ms').to('best').toString();
}
//# sourceMappingURL=ms.js.map